const gallery = [
  {
    id: 1,
    image_url: "/images/gallery/gallery1.jpg",
    caption: "The 1st Divisional Meeting of UNGEGN ASE Division",
    location: "Brunei Darussalam",
    date: "13-14 May 2013",
    link: "https://web.facebook.com/media/set/?set=a.10151613535119228.1073741833.90754969227&type=3&_rdc=1&_rdr"
  },
  {
    id: 2,
    image_url: "/images/gallery/gallery2.jpg",
    caption: "The 5th Divisional Meeting of UNGEGN ASE Division",
    location: "UN Headquarters",
    date: "9 August 2017",
    link: "https://web.facebook.com/media/set/?set=a.10151613535119228.1073741833.90754969227&type=3&_rdc=1&_rdr"
  },
  {
    id: 3,
    image_url: "/images/gallery/ev18oneposter.jpg",
    caption: "The 1st Regional Training Program in Toponymy including Marine Toponymy",
    location: "Philippines",
    date: "19-24 March 2018",
    link: "https://web.facebook.com/media/set/?set=a.10151613535119228.1073741833.90754969227&type=3&_rdc=1&_rdr"
  },
  {
    id: 4,
    image_url: "/images/gallery/mt18oneposter.jpg",
    caption: "The 6th Divisional Meeting of UNGEGN ASE Division",
    location: "Philippines",
    date: "26 March 2018",
    link: "https://web.facebook.com/media/set/?set=a.10151613535119228.1073741833.90754969227&type=3&_rdc=1&_rdr"
  },
  {
    id: 5,
    image_url: "/images/gallery/mt19twoposter.png",
    caption: "The 7th Divisional Meeting of UNGEGN ASE Division",
    location: "UN Headquarters",
    date: "1 May 2019",
    link: "https://web.facebook.com/media/set/?set=a.10151613535119228.1073741833.90754969227&type=3&_rdc=1&_rdr"
  },
  
];

export default gallery;
